"use stric";

import api from "./apiService.js";

const AccountService = {
  logIn: function (options) {
    return api.post("accounts/signin", options);
  },
  logInDemo: function (options) {
    return api.post("accounts/signin/demo", {});
  },
  getOAuth2Parametrs: function () {
    return api.get("Accounts/OAuth2/Params", { params: {} });
  },
  logInOAuth2: function (options) {
    return api.post("/Accounts/OAuth2/SignIn", options, { params: {} });
  },
  logOut: function (options) {
    return api.post("account/logout", { params: options });
  },
  getRegistrationUser: function (options) {
    return api.get("accounts/Registration", { params: options });
  },
  registration: function (options) {
    return api.put("accounts/Registration", options, {});
  },
  sendEmail: function (options) {
    return api.post("accounts/Restore", options);
  },
  getRestoreData: function (options) {
    return api.get("accounts/Restore", { params: options });
  },
  restorePassword: function (options) {
    return api.put("accounts/Restore", options, {});
  },
};

export default AccountService;
